import ModalDelete from 'components/ModalDelete'
import React, { useEffect, useState } from 'react'
import { lang } from 'utils/helpers'

const ModalVirusAttachments = (props) => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [checkFirts, setCheckFirts] = useState(false)
  const { attachments } = props
  useEffect(() => {
    const withVirus = (attachments || []).some(attachment => attachment.withVirus)
    if(!checkFirts && withVirus){
      setIsOpenModal(withVirus)
      setCheckFirts(true)
    }
  }, [attachments])

  return (
    <ModalDelete
      isOpen={isOpenModal}
      toggle={() => setIsOpenModal(!isOpenModal)}
      header={lang('dashboard_malicious-content-title')}
      text1={lang('dashboard_malicious-content-legend')}
      text2={lang('dashboard_delete_files_with_virus')}
      textBtn1={lang('dashboard_understand')}
    />
  )
}

export default ModalVirusAttachments